import type { AuthFetch } from './frontend-auth/auth-wrapper';
import { checkEditorResponse } from './editor-errors';

export interface Candidate {
    DomainId: string;
    IntegrationSettingsId: number;
    GroupId: string;
    JobId: string;
    JobTitle: string;
    CandidateId: string;
    FirstName: string;
    LastName: string;
    CandidateName: string;

    DocumentIds: string[];
    DocumentTypes: number[];
    DocumentJobs: string[];

    /**
     * If computed, the filter match score.
     */
    score?: number;
}

export interface CandidateSnapshot {
    Candidates: Candidate[];
    Timestamp: string;
}

/** Shares list requests while keeping direct document links independent of the list. */
export class CandidateData {
    private pending?: Promise<CandidateSnapshot>;

    private authFetch: AuthFetch;

    constructor(authFetch: AuthFetch) { this.authFetch = authFetch; }

    list(refresh = false): Promise<CandidateSnapshot> {
        if (!this.pending || refresh) {
            const request = this.authFetch(refresh ? '/refresh' : '/list')
                .then(checkEditorResponse)
                .then(response => response.json() as Promise<CandidateSnapshot>);
            this.pending = request;
            // A failed request must not poison future sidebar opens or refreshes.
            void request.catch(() => {
                if (this.pending === request) this.pending = undefined;
            });
        }
        return this.pending;
    }

    async candidate(jobId: string, candidateId: string): Promise<Candidate | null> {
        const query = new URLSearchParams({ job_id: jobId, candidate_id: candidateId });
        const response = await this.authFetch(`/candidate?${query}`);
        if (response.status === 404) return null;
        checkEditorResponse(response);
        return response.json() as Promise<Candidate>;
    }
}
